import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Location } from "@/components/site/Location";
import { Footer } from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#050505] text-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Testimonials />
        <Contact />
        <Location />
      </main>
      <Footer />
    </div>
  );
}
